import { useCallback, useContext } from 'react'
import AppContext from '../../context/appContext'
import { processLoading, ProcessLoadingProps } from './processLoading'

type SimpleProcessLoadingProps = Pick<
  ProcessLoadingProps,
  | 'doAction'
  | 'loadingMessage'
  | 'errorMessage'
  | 'successfulMessage'
  | 'contactReasonSupportType'
  | 'displayErrorMessageMode'
>

export function useProcessLoading(): {
  processLoading: (props: SimpleProcessLoadingProps) => Promise<void>
} {
  const { setLoadingModalConfig } = useContext(AppContext)

  const handleProcessLoading = useCallback(
    async ({
      doAction,
      loadingMessage,
      errorMessage,
      successfulMessage = '',
      contactReasonSupportType,
      displayErrorMessageMode,
    }: SimpleProcessLoadingProps) =>
      processLoading({
        setLoadingModalConfig,
        loadingMessage,
        successfulMessage,
        errorMessage,
        contactReasonSupportType,
        displayErrorMessageMode,
        doAction,
      }),
    [setLoadingModalConfig],
  )

  return { processLoading: handleProcessLoading }
}
